<template>
  <div class="logistics">
    <top-nav ref="TopNav"></top-nav>
    <van-nav-bar title="物流详情" fixed left-arrow @click-left="goBack" @click-right="onClickRight" style="z-index: 3">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div class="van-content">
      <van-cell-group>
        <div class="van-card">
          <!-- <div class="van-card__thumb">
            <img v-lazy="datas.img"/>
          </div> -->
          <div class="van-card__content">
            <!-- <div class="van-card-title theme-col">&nbsp;</div> -->
            <div style="margin-top: 7px;">快递公司：{{ datas.expName }}</div>
            <div>快递单号：{{ expressCode }}</div>
          </div>
        </div>
      </van-cell-group>
      <van-cell-group>
        <van-cell>
          订单追踪
        </van-cell>
        <van-steps direction="vertical" :active="0" active-color="#06bf04">
          <van-step v-for="(items,index) in datas.expTrack" :key="items.id">
            <p :class="{'theme-col': index == 0}">{{ items.status }}</p>
            <p :class="{'theme-col': index == 0}">{{ items.ftime }}</p>
          </van-step>
        </van-steps>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
  import TopNav from '@/components/topnav'
  export default {
    name: "logistics",
    components: {
      TopNav
    },
    data () {
      return {
        datas:'',
        expressCode:this.$route.query.expresscode,
        goodsId:this.$route.query.goodsid,
        orderId:this.$route.query.orderid
      }
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/JifenOrder/Order/logistics', {token:isUser,express_code:this.expressCode,goods_id:this.goodsId,order_id:this.orderId}, res => {
          if(res.data.errCode == '0000'){
            this.datas = res.data.express_data
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
    },
    mounted () {
      this.getDatas()
    }
  }
</script>

<style lang="less" scoped>
  .logistics{
    .van-cell-group{
      background-color: #fff;
    }
    .van-cell:not(:last-child)::after{
      border-bottom-width:0;
    }
    .van-step--vertical p{
      margin-bottom: 10px;
    }
    .van-card{
      background-color: #fff;
      height: 60px;
      padding-left: 15px;
      .van-card__thumb{
        width: 65px;
        height: 65px;
      }
    }
    .van-step--vertical:not(:last-child)::after{
      border-bottom-width: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/logistics.vue